const reviews = [
  {
    name: 'Nick D.',
    location: 'Hayden, ID',
    rating: 5,
    text: 'Great people and excellent work! CQC delivered exactly what we needed — professional, clean, and right on time. Our outdoor space is completely transformed. Would absolutely hire again.',
    service: 'Landscaping',
    initials: 'ND',
  },
  {
    name: 'Jane Reid',
    location: 'Post Falls, ID',
    rating: 5,
    text: 'Reasonable pricing, quick response, and great results. They showed up fast, finished ahead of schedule, and left everything spotless. Really happy with the whole experience.',
    service: 'Lawn & Landscape',
    initials: 'JR',
  },
  {
    name: 'Ronald Butts',
    location: 'North Idaho',
    rating: 5,
    text: "These guys are the real deal — super friendly, very helpful, and incredibly clean with their work. I've referred them to builders and homeowners alike and never once had a bad report. Keep it up, Charles!",
    service: 'Retaining Wall & Landscaping',
    initials: 'RB',
  },
  {
    name: 'Verified Client',
    location: "Coeur d'Alene, ID",
    rating: 5,
    text: 'CQC completely transformed our property. The patio is stunning, drainage is perfect, and the retaining wall is exactly what we envisioned. Professional and respectful crew throughout.',
    service: 'Hardscaping & Drainage',
    initials: 'VC',
  },
];

export default function Testimonials() {
  const [featured, ...rest] = reviews;

  return (
    <section className="w-full bg-white py-28">
      <div className="max-w-7xl mx-auto px-6 lg:px-12">

        {/* Header */}
        <div className="flex flex-col lg:flex-row lg:items-end lg:justify-between gap-6 mb-16">
          <div>
            <div className="flex items-center gap-3 mb-5">
              <div className="h-px w-10 bg-gold"></div>
              <span className="font-sans text-[10px] tracking-[0.25em] uppercase text-gold">Client Reviews</span>
            </div>
            <h2 className="font-serif text-forest font-semibold leading-tight" style={{ fontSize: 'clamp(2.2rem, 4vw, 3.2rem)' }}>
              What Our Clients Say
            </h2>
          </div>
          <div className="flex flex-col items-start lg:items-end gap-2">
            <div className="flex items-center gap-1">
              {[0,1,2,3,4].map(i => <i key={i} className="ri-star-fill text-gold text-xl"></i>)}
            </div>
            <span className="font-sans text-charcoal-muted text-sm">5.0 average · Google Reviews</span>
          </div>
        </div>

        {/* Layout */}
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-5">

          {/* Featured — large editorial card */}
          <div className="lg:col-span-5 bg-[#07140a] rounded-2xl p-10 flex flex-col justify-between">
            <div>
              {/* Stars */}
              <div className="flex items-center gap-1 mb-6">
                {[0,1,2,3,4].map(i => <i key={i} className="ri-star-fill text-gold text-base"></i>)}
              </div>

              {/* Quote — large serif */}
              <p className="font-serif italic text-white/85 leading-relaxed mb-8" style={{ fontSize: 'clamp(1.1rem, 1.8vw, 1.35rem)' }}>
                &ldquo;{featured.text}&rdquo;
              </p>
            </div>

            {/* Author */}
            <div className="flex items-center gap-3 pt-8 border-t border-white/10">
              <div className="w-11 h-11 flex items-center justify-center rounded-full bg-gold text-forest-deep font-bold text-sm font-sans shrink-0">
                {featured.initials}
              </div>
              <div>
                <div className="font-sans font-bold text-white text-sm">{featured.name}</div>
                <div className="font-sans text-white/40 text-xs">{featured.location} · {featured.service}</div>
              </div>
              <div className="ml-auto">
                <a href="https://www.google.com/maps/place/CQC+Landscaping" target="_blank" rel="noreferrer noopener" className="font-sans text-[9px] tracking-[0.12em] text-white/25 hover:text-gold uppercase transition-colors cursor-pointer">Google ↗</a>
              </div>
            </div>
          </div>

          {/* Secondary cards */}
          <div className="lg:col-span-7 grid grid-cols-1 md:grid-cols-2 gap-5 content-start">
            {rest.map((r, i) => (
              <div key={i} className="bg-[#f5f0e8] rounded-2xl p-7 border border-stone/40 hover:border-gold/30 hover:shadow-md transition-all flex flex-col justify-between">
                <div>
                  <div className="flex items-center justify-between mb-4">
                    <div className="flex items-center gap-0.5">
                      {[0,1,2,3,4].map(s => <i key={s} className="ri-star-fill text-gold text-xs"></i>)}
                    </div>
                    <span className="font-sans text-[10px] text-charcoal-muted uppercase tracking-wide">{r.service}</span>
                  </div>
                  <p className="font-sans text-sm text-charcoal-mid leading-relaxed mb-5">
                    &ldquo;{r.text}&rdquo;
                  </p>
                </div>
                <div className="flex items-center gap-3 pt-4 border-t border-stone/50">
                  <div className="w-8 h-8 flex items-center justify-center rounded-full bg-forest text-white text-xs font-bold font-sans shrink-0">
                    {r.initials}
                  </div>
                  <div>
                    <div className="font-sans font-bold text-forest text-xs">{r.name}</div>
                    <div className="font-sans text-charcoal-muted text-xs">{r.location}</div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* Google CTAs */}
        <div className="mt-10 flex flex-wrap gap-4 justify-center">
          <a href="https://www.google.com/maps/place/CQC+Landscaping/@47.7693454,-117.1510443,10z/data=!4m8!3m7!1s0x5361c064d62d06bf:0xf3c8b15e4ac6639d!8m2!3d47.7693454!4d-117.1510444!9m1!1b1!16s%2Fg%2F11b7kcqjsh?entry=ttu"
            target="_blank" rel="noreferrer noopener"
            className="whitespace-nowrap inline-flex items-center gap-2 border border-forest/30 text-forest font-semibold text-sm rounded-full px-6 py-3 hover:bg-forest hover:text-white transition-all cursor-pointer">
            <i className="ri-google-fill"></i> Read All Google Reviews
          </a>
          <a href="https://g.page/r/CZ1jxkpescjzEBM/review" target="_blank" rel="noreferrer noopener"
            className="whitespace-nowrap inline-flex items-center gap-2 bg-gold hover:bg-gold-light text-forest-deep font-bold text-sm rounded-full px-6 py-3 transition-all cursor-pointer shadow-lg shadow-gold/20">
            <i className="ri-star-fill"></i> Leave a Review
          </a>
        </div>
      </div>
    </section>
  );
}
